import { render, staticRenderFns } from "./RoleSelector.vue?vue&type=template&id=ca033ad4&scoped=true&"
import script from "./RoleSelector.vue?vue&type=script&lang=js&"
export * from "./RoleSelector.vue?vue&type=script&lang=js&"
import style0 from "./RoleSelector.vue?vue&type=style&index=0&id=ca033ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca033ad4",
  null
  
)

export default component.exports